import { render, staticRenderFns } from "./DetailsPopOver.vue?vue&type=template&id=1ea3a294&scoped=true&"
import script from "./DetailsPopOver.vue?vue&type=script&lang=js&"
export * from "./DetailsPopOver.vue?vue&type=script&lang=js&"
import style0 from "./DetailsPopOver.vue?vue&type=style&index=0&id=1ea3a294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea3a294",
  null
  
)

export default component.exports